export const BODY_MAX_WIDTH = '540px'
export const HEADER_HEIGHT = '80px'
export const MAIN_LAYOUT_MENU_ID = 'MAIN_LAYOUT_MENU'
